import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ChordBarsIcon } from '../../../../icons/chord-bars.svg';
import { ReactComponent as MicIcon } from '../../../../icons/microphone.svg';

const ChartsPill = ({ charted, total, hasLyricsCharts, onOpen }) => {
  const { t } = useTranslation();
  // Rounded down as the service list's is, so a song a part short never reads as 100%
  const percent = total > 0 ? Math.floor((charted / total) * 100) : 0;

  return (
    <button
      type="button"
      className="charts-pill"
      onClick={onOpen}
      title={t('view.chartsTitle')}
      aria-label={t('view.chartsLabel', { charted, total })}
    >
      <ChordBarsIcon className="charts-pill__icon" aria-hidden="true" />
      {hasLyricsCharts && <MicIcon className="charts-pill__icon charts-pill__icon--mic" aria-hidden="true" />}
      <span className="charts-pill__label">
        {charted === total ? t('charts.charted') : t('charts.percentCharted', { percent })}
      </span>
    </button>
  );
};

ChartsPill.propTypes = {
  /** Chartable parts that have a chart, out of `total` — see getChartCoverage */
  charted: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  hasLyricsCharts: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
};

export default ChartsPill;
